module.exports = __webpack_public_path__ + "static/ms-outlook-ef8396265a9a0edd4f12ccff2f20db8b.png";